// @ts-nocheck
import { parse as urlParse, UrlWithStringQuery } from 'url';

import { PostOrPage } from '@tryghost/content-api';
import { rehype } from 'rehype';
import { Node as UnistNode } from 'unist';
import { visit } from 'unist-util-visit';

import { createNextProfileImagesFromAuthors } from './ghost-images';
import { GhostPostOrPage } from './ghost-interfaces';
import { Dimensions } from 'research/types/src/utils/lib/images';

/**
 * Rewrite ghost links to be used with next/link
 *
 * @param cmsUrl
 * @param basePath
 */
const withRewriteGhostLinks = (cmsUrl: UrlWithStringQuery, basePath = '/') => {
    return (htmlAst: Node) => {
        visit(htmlAst, { tagName: `a` }, (node: LinkElement) => {
            if (!node.properties) return;

            const href = urlParse(node.properties.href);
            if (href.protocol === cmsUrl.protocol && href.host === cmsUrl.host) {
                node.properties.href = `${basePath}${href.pathname?.substring(1)}${href.hash}`;
            }
        });

        return htmlAst;
    };
};

/**
 * Rewrite relative links to be used with next/link
 */
/*
const rewriteRelativeLinks = (htmlAst: Node) => {
    visit(htmlAst, { tagName: `a` }, (node: LinkElement) => {
        const href = node.properties?.href;
        if (href && !href.startsWith(`http`)) {
            const copyOfNode = JSON.parse(JSON.stringify(node));
            delete copyOfNode.properties;
            delete copyOfNode.position;
            copyOfNode.tagName = `span`;
            node.tagName = `Link`;
            node.children = [copyOfNode];
        }
    });
};
*/
/*
const rewriteRelativeLinksMapped = (htmlAst: Node) => {
    return map(htmlAst, node => {
        const href = node.properties?.href;
        if (href && !href.startsWith(`http`)) {
            const copyOfNode = JSON.parse(JSON.stringify(node));
            delete copyOfNode.properties;
            delete copyOfNode.position;
            copyOfNode.tagName = `span`;
            node.tagName = `Link`;
            node.children = [copyOfNode];
        }

        return node;
    });
};
*/

export const normalizePostSimple = (post: PostOrPage): GhostPostOrPage => {
    // image meta
    const url = post.feature_image;

    // const dimensions = await imageDimensions(url)
    const dimensions: Dimensions = {
        width: 0,
        height: 0,
    };

    // author images
    const authors = createNextProfileImagesFromAuthors(post.authors);

    return {
        ...post,
        authors,
        htmlAst,
        featureImage: (url && dimensions && { url, dimensions }) || null,
    };
};

export const normalizePost = async (
    post: PostOrPage,
    cmsUrl: UrlWithStringQuery | undefined,
    basePath?: string
): Promise<GhostPostOrPage> => {
    if (!cmsUrl) throw Error('ghost-normalize.ts: cmsUrl expected.');
    const rewriteGhostLinks = withRewriteGhostLinks(cmsUrl, basePath);

    const processors = [
        rewriteGhostLinks,
        // rewriteRelativeLinks,
        /* syntaxHighlightWithPrismJS, rewriteInlineImages, */
    ];

    let htmlAst = rehype.parse(post.html || '');
    for (const process of processors) {
        htmlAst = await process(htmlAst);
    }

    // image meta
    const url = post.feature_image;

    // const dimensions = await imageDimensions(url)
    const dimensions: Dimensions = {
        width: 0,
        height: 0,
    };

    // author images
    const authors = await createNextProfileImagesFromAuthors(post.authors);

    return {
        ...post,
        authors,
        htmlAst,
        featureImage: (url && dimensions && { url, dimensions }) || null,
    };
};

/**
 * Rewrite absolute Ghost CMS links to relative
 */
interface Node extends UnistNode {
    value?: string;
}

interface LinkElement extends Node {
    tagName: string;
    properties?: HTMLAnchorElement;
    children?: Node[];
}

export default normalizePost;
